<template>
  <v-container fill-height class="full-width pt-5 pb-6 white-bg">
    <v-layout class="wrapper full-width">
      <v-row class="full-height">
        <v-col cols="3" class="ml-3" align="left" justify="space-between">
          <div>
            <h1>natur stiften with</h1>
            <img
              :src="require('../assets/wdb_logo.png')"
              alt="logo"
              class="mt-1 mb-1"
              style="width: 62%"
            />
          </div>
          <div>
            <img src="../assets/left-top.jpg" alt="boat" class="left-img" />
            <img src="../assets/left-bottom.jpg" alt="nest" class="left-img" />
          </div>
        </v-col>
        <v-col cols="6" class="mr-6 mt-5" align="left">
          <h2 class="mb-2 mt-16">
            Together with why do birds, you have made a contribution to protect
            and preserve the native bird species in Brandenburg. With this
            special Christmas gift, we are supporting the project ”Natur
            stiften” and the construction of a breeding island for waterbirds.
          </h2>
          <h2 class="mb-8">Because: We like birds!</h2>
          <h3 class="mb-5">
            Nowadays, not only songbirds are endangered, but also many
            waterfowl. The island offers protection from predators and is
            suitable as a breeding and resting place for various waterfowl such
            as common terns, ducks, geese, herons or swans where they can raise
            their offspring on the islandin a natural environment. But also
            other species benefit from the project, as the acquisition of the
            water surface and the adjacent shore area secures and preserves
            untouched nature in the long term.
          </h3>
          <h3>
            This November, we helped to place breeding baskets in the old peat
            pondof Saalow, an old mill village south of Berlin. Milan Hänsel,
            head of the project, started the preparation of the wood this fall
            to begin the con-struction of the breeding island soon. The island
            will be equipped with coarse-grained gravel, shelters and rootstocks
            made of regional timber to provide pro-tection for the nestlings.
            The constructions are designed to blend perfectly into the
            surrounding nature and transform it into an ever more valuable
            habitat in the near future.
          </h3>
          <v-btn
            rounded
            outlined
            class="about-birds-btn mt-13"
            @click="goTo('Encyclopedia')"
            ><p>About the birds</p></v-btn
          >
        </v-col>

        <v-col align="end" justify="space-around">
          <img
            src="../assets/page-right.jpg"
            alt="nest"
            class="left-img mb-16"
          />
          <v-btn
            small
            color="transparent"
            elevation="0"
            class="imprint-btn"
            @click="goTo('Imprint')"
            >Imprint</v-btn
          >
        </v-col>
      </v-row>
    </v-layout>
  </v-container>
</template>

<script>
import router from "../router/index";

export default {
  name: "About",
  methods: {
    goTo(route) {
      router.push({ name: route });
    },
  },
};
</script>

<style scoped>
.v-btn {
  height: 50px !important;
  min-width: 180px;
}
.wrapper {
  margin: 0 !important;
  height: 90%;
}
.full-width {
  max-width: none !important;
  padding: 0;
  width: 100% !important;
}

h3 {
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 25px;
  color: #000000;
}
h2 {
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0.02em;
  color: #000000;
  font-family: "MabryMedium";
}
h1 {
  font-family: "MabryBold";
  font-style: normal;
  font-weight: bold;
  width: 100%;
  font-size: 1.7vw;
  line-height: 29px;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  color: #000000;
  text-align: left;
  margin-bottom: 5px;
}
span {
  color: #22534a;
}
.left-img {
  width: 90%;
  margin-top: 15px;
}
.justify-vertically-space-between {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-between;
  width: 100%;
  height: 85%;
}
.imprint-btn {
  font-style: normal;
  font-weight: normal;
  font-family: "MabryBold";
  font-size: 12px;
  line-height: 22px;
  align-self: center;
  margin-top: 45%;
  position: fixed;
  bottom: 3%;
  right: 2%;
}
.about-birds-btn {
  border: 2px solid #92a2ff;
  width: 330px;
  stroke-width: 2px !important;
}
.about-birds-btn p {
  font-style: normal;
  font-weight: bold;
  align-self: center;
  margin: auto;
  font-size: 12px;
  line-height: 22px;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  font-family: "MabryBold";
  color: #0b3530 !important;
}
.white-bg {
  background-color: white;
}
</style>